import { decamelizeKeys } from 'humps';

function createQueryParams(params: object) {
  const decamelizedParams = Object.entries(decamelizeKeys(params));
  const activeParams = decamelizedParams.filter(([, value]) => {
    if (Array.isArray(value)) {
      return value.length > 0;
    }

    return value !== undefined && value !== null;
  });

  const searchParams = new URLSearchParams();

  activeParams.forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(item => {
        searchParams.append(`${key}[]`, String(item));
      });
    } else {
      searchParams.append(key, String(value));
    }
  });

  return searchParams.toString();
}

export { createQueryParams };
